'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _UploadOutlined = _interopRequireDefault(require('./lib/icons/UploadOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _UploadOutlined;
exports.default = _default;
module.exports = _default;